import { styled } from 'styled-components'

export const Popover = styled.div`
  position: relative;

  svg {
    font-size: 20px;
  }
`

export const BellButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 52px;
  height: 52px;

  border-radius: 50%;
  border: 1px solid #8e92bc;
  background: transparent;
  color: #8e92bc;
  cursor: pointer;

  transition:
    transform 0.12s ease,
    background 0.12s ease;

  &:hover {
    transform: translateY(-1px);
    background: #fbf8d5;
  }

  &:focus-visible {
    outline: 2px solid #ffdc50;
    outline-offset: 2px;
  }

  @media screen and (max-width: 700px) {
    width: 44px;
    height: 44px;
  }
`

export const Badge = styled.div`
  position: absolute;
  top: -3px;
  right: -3px;

  min-width: 18px;
  height: 18px;
  padding: 0 6px;

  border-radius: 999px;
  background: #ffdc50;
  color: #313131;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  font-size: 11px;
  font-weight: 700;
  line-height: 1;
`

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 90;
  background: transparent;
`

export const Panel = styled.div`
  position: absolute;
  right: 0;
  top: calc(100% + 10px);
  z-index: 100;
  text-align: left;
  width: 360px;
  max-height: 520px;

  border-radius: 18px;
  background: #fcfbf2;
  backdrop-filter: blur(14px);

  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.35);
  overflow: hidden;

  @media screen and (max-width: 700px) {
    left: -230px;
  }
`

export const HeaderRow = styled.div`
  padding: 18px 14px 0px 18px;
  /* border-bottom: 1px solid #ffe57f; */
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  position: relative;
  margin-bottom: 10px;

  .close {
    border: 0;
    position: absolute;
    top: -3px;
    right: -5px;
    background: transparent;
    cursor: pointer;

    svg {
      font-size: 25px;
    }

    &:focus-visible {
      outline: 2px solid #ffc400;
      outline-offset: 3px;
      border-radius: 10px;
    }
  }
`

export const PanelTitle = styled.div`
  font-size: 14px;
  font-weight: 800;
`

export const SubTitle = styled.div`
  font-size: 14px;
  margin-top: 2px;
`

export const Items = styled.div`
  padding: 6px;
  overflow: auto;
  max-height: 430px;
`

export const Item = styled.div<{ $unread?: boolean }>`
  padding: 12px 12px;
  border-radius: 14px;
  cursor: pointer;

  background: ${({ $unread }) => ($unread ? '#ffd740' : 'transparent')};
  border: 1px solid ${({ $unread }) => ($unread ? '#ffd740' : 'transparent')};

  transition:
    background 0.12s ease,
    border-color 0.12s ease;

  &:hover {
    background: ${({ $unread }) => ($unread ? '#ffd740' : '#FFDC50')};
  }

  .title {
    font-size: 13px;
    font-weight: 800;
  }

  .body {
    margin-top: 6px;
    font-size: 12px;
    line-height: 1.35;
  }

  .date {
    font-size: 11px;
  }
`

export const Row = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
`

export const EmptyState = styled.div`
  padding: 18px 14px;
  font-size: 12px;
`

export const PanelFooter = styled.div`
  padding: 10px 12px;
  border-top: 1px solid #ffd740;
  display: flex;
  justify-content: flex-end;
`
